import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "primereact/button";
import EzTable from "../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../common/EzToast";
import EzNotFound from "../../common/EzNotFound";
import EzTableNested from "../../common/EzTable/NestedTable";
import UploadModal from "../../common/UploadModal";
const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
let SelectedRecords = [];

const Transaction = (props) => {
  const {
    fetchTransactions,
    tableData,
    importTransaction,
    validateTransaction,
    history,
    initTransactionScreen,
    showPageLevelLoader,
    transactionsListView,
    isPageLevelError,
    paginationInfo,
    isLoading,
    exportTransaction,
    screenPermissions,
    editTransaction,
    viewTransaction,
    validateResult,
  } = props;

  const [areFiltersVisible, toggleFilterState] = useState(false);
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [validateModalVisible, setValidateModalVisible] = useState(false);

  useEffect(() => {
    if (!validateResult) return;
    const isClean = typeof validateResult.message === "string";
    let html;
    if (isClean) {
      html = `<html><body style="font-family:Arial,sans-serif;padding:40px"><h2 style="color:#16a34a">&#10003; ${validateResult.message}</h2></body></html>`;
    } else {
      const sections = Object.entries(validateResult.message).map(([title, detail]) => {
        const cards = detail.replace(/^.*?:\s*/, "").split(",").map(c => c.trim()).filter(Boolean);
        const isMissing = title === "Cards Missing";
        const color = isMissing ? "#dc2626" : "#b45309";
        const bg = isMissing ? "#fef2f2" : "#fffbeb";
        const border = isMissing ? "#fca5a5" : "#fcd34d";
        const chips = cards.map(c =>
          `<span style="display:inline-block;background:${bg};border:1px solid ${border};border-radius:6px;padding:4px 10px;margin:4px;font-size:13px;font-family:monospace;color:${color}">${c}</span>`
        ).join("");
        return `<div style="margin-bottom:28px">
          <h3 style="color:${color};margin-bottom:10px">${title} (${cards.length})</h3>
          <div>${chips}</div>
        </div>`;
      }).join("");
      html = `<html><head><title>Validation Results</title></head><body style="font-family:Arial,sans-serif;padding:40px"><h2 style="margin-bottom:24px">Validation Results</h2>${sections}</body></html>`;
    }
    const blob = new Blob([html], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    const tab = window.open(url, "_blank");
    if (tab) setTimeout(() => URL.revokeObjectURL(url), 5000);
  }, [validateResult]);
  const [toastProps, setToastProps] = useState({
    severity: "",
    toastTitle: "",
    shouldShowToast: false,
  });

  const handleFileUpload = (file, fileType, resetState, beginDate, endDate, medium) => {
    const payload = { file, type: fileType, begin_date: beginDate, end_date: endDate, medium };
    importTransaction(payload);
    resetState();
  };

  const importTransactionModel = () => {
    setUploadModalVisible(true);
  };

  const handleValidateUpload = (file, fileType, resetState, beginDate, endDate, medium) => {
    const payload = { type: fileType, file, begin_date: beginDate, end_date: endDate, medium };
    validateTransaction(payload);
    resetState();
  };

  const showToast = (severity, toastTitle, duration = 3000) => {
    setToastProps({
      severity,
      toastTitle,
      shouldShowToast: true,
    });

    setTimeout(() => {
      setToastProps((prev) => ({
        ...prev,
        shouldShowToast: false,
      }));
    }, duration);
  };

  const exportTransactions = () => {
    if (!SelectedRecords || SelectedRecords.length === 0) {
      showToast(TOAST_SEVERITY.INFO, "Please select at least one transaction to export.");
      return;
    }

    const payload = SelectedRecords.map((item) => item.id);
    exportTransaction(payload);
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative">
        <div
          className=""
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div className="ml-3">
              <h4>Transactions</h4>
            </div>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div>
            <Button
              label={"Export Transactions"}
              className={` p-button-raised`}
              onClick={exportTransactions}
            />
            {screenPermissions?.create && (
              <Button
                label={"Import Transactions"}
                className={` p-button-raised ml-2`}
                onClick={importTransactionModel}
              />
            )}
            <Button
              label={"Validate Transactions"}
              className={`p-button-raised ml-2`}
              onClick={() => setValidateModalVisible(true)}
            />
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();
  const filters = {
    global: { value: null },
    authentication_id: { filterKey: "authentication_id", value: null },
    txn_date: { filterKey: "txn_date", value: null },
    card_number: { filterKey: "card_number", value: null },
    txn_station: { filterKey: "txn_station", value: null },
    dtl_stn_prv: { filterKey: "dtl_stn_prv", value: null },
    dtl_stn_addr: { filterKey: "dtl_stn_addr", value: null },
    txn_company: { filterKey: "txn_company", value: null },
    txn_amount: { filterKey: "txn_amount", value: null },
    hdr_currency: { filterKey: "hdr_currency", value: null },

    dtl_auth_id: { filterKey: "dtl_auth_id", value: null },
    txn_fuel_type: { filterKey: "txn_fuel_type", value: null },
    txn_price_per_unit: { filterKey: "txn_price_per_unit", value: null },
    dtl_fet_rt: { filterKey: "dtl_fet_rt", value: null },
    dtl_gst_amt: { filterKey: "dtl_gst_amt", value: null },
    dtl_hst_amt: { filterKey: "dtl_hst_amt", value: null },
    dtl_price_wo_tax: { filterKey: "dtl_price_wo_tax", value: null },
    pct: { filterKey: "pct", value: null },
    dtl_pft_rt: { filterKey: "dtl_pft_rt", value: null },
    dtl_pst_amt: { filterKey: "dtl_pst_amt", value: null },
    dtl_qst_amt: { filterKey: "dtl_qst_amt", value: null },
    dtl_amt: { filterKey: "dtl_amt", value: null },
  };
  const handleCallback = (childData) => {
    SelectedRecords = childData;
  };
  let isCallbackEnable = true;
  const tableProps = {
    areFiltersVisible,
    columns: tableData?.columns,
    subcolumns: tableData?.subcolumns,
    paginationInfo,
    screenPermissions,
    showViewButton: false,
    value: tableData?.rows,
    emptyMessage: "No Transaction found.",
    filters,
    loadLazyData: fetchTransactions,
    loading: false,
    showMoreActions: false,
    sortField: null,
    isLoading,
    onEditRecord: editTransaction,
    onReadRecord: viewTransaction,
    SUBKEY: "sub_transactions",
    parentCallback: handleCallback,
    isCallbackEnable,
  };
  return (
    <>
      <EzToast {...toastProps} />
      <div className="paddingbox">
        <div className="containerbox">
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Row>
                <Col md={12}>
                  <EzTableNested {...tableProps} />
                </Col>
              </Row>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No transaction records to show"}
              />
            )}
          </div>
          <UploadModal
            visible={uploadModalVisible}
            onHide={() => setUploadModalVisible(false)}
            onUpload={handleFileUpload}
          />
          <UploadModal
            header="Validate Transactions"
            visible={validateModalVisible}
            onHide={() => setValidateModalVisible(false)}
            onUpload={handleValidateUpload}
            fileOptional
          />


        </div>
      </div>
    </>
  );
};
export default Transaction;
